import { IPlatform } from '@/types';
import { Section } from '../section/section.comp';
import { StyledDiv } from './platformOverview.styles';

export const PlatformOverview = ({
	platform,
}: {
	platform: Partial<IPlatform>;
}) => {
	if (!platform.description) {
		return <></>;
	}
	return (
		<Section>
			<StyledDiv>
				<p className="subtitle">Platform Overview</p>
				<h2>
					What are {platform.displayName} {platform.appSynonym}s
				</h2>
				<div
					className="desc"
					dangerouslySetInnerHTML={{
						__html: (platform as IPlatform).description,
					}}
				></div>
			</StyledDiv>
		</Section>
	);
};
